import AiConfigView from './AiConfigView.vue';

export default [
  {
    path: '/app/accounts/:accountId/ai-config',
    name: 'ai_config_index',
    component: AiConfigView,
    meta: {
      requiresAuth: true,
      layout: 'dashboard',
      permissions: ['administrator', 'agent'],
    },
  },
];